import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

import { UnifiedPromptuaryService } from '../promptuary-form/unified-promptuary.service';

@Component({
	selector: 'promptuary-service-evolution-crm',
	templateUrl: './promptuary-service-evolution-crm.component.html',
	styleUrls: ['./promptuary-service-evolution-crm.component.scss'],
})
export class PromptuaryServiceEvolutionCRMComponent {
	@Input()
	autoSaveData;
	@Input()
	formGroup: FormGroup;
	@Input()
	step: number;

	constructor(
		public unifiedPromptuary: UnifiedPromptuaryService,
		public promptuaryService: PromptuaryService
	) {}
}
